import {Component, HostBinding, Input, TemplateRef} from '@angular/core';
import {toggleOpenTrigger} from '../../../../@theme/animations';

export interface DetailRowAction {
    icon: string;
    label: string;
    action: () => any;
    condition?: () => boolean;
    getActive?: () => boolean;
    getVisible?: () => boolean;
}

@Component({
    selector: 'app-detail-row',
    templateUrl: './detail-row.component.html',
    host: {
        class: 'detail-row',
    },
    animations: [
        toggleOpenTrigger,
    ],
})
export class DetailRowComponent {
    @Input() icon: string;
    @Input() label: string;
    @Input() content: string | number;
    @Input() contentTmp: TemplateRef<any>;
    @Input() labelExtraTmp: TemplateRef<any>;
    @Input() editViewTmp: TemplateRef<any>;

    @Input() displayLabel = true;
    @Input() actions: DetailRowAction[];
    @Input() isEditing: boolean;
    @Input() hasError: boolean;
    @Input() errorMessage: string;
    @Input() hasWarning: boolean;
    @Input() warningMessage: string;
    @Input() isUpdated: boolean;
    @Input() updatesContent: string | number;

    @HostBinding('class.detail-row-editing') get showEditingState() {
        return this.isEditing;
    }

    @HostBinding('class.detail-row-error') get showErrorState() {
        return !this.showEditingState && this.hasError;
    }

    @HostBinding('class.detail-row-warning') get showWarningState() {
        return !this.showEditingState && !this.hasError && this.hasWarning;
    }

    @HostBinding('class.detail-row-updated') get showUpdatedState() {
        return !this.showEditingState && !this.showErrorState && !this.showWarningState && this.isUpdated;
    }
}
